/**
 * Lazy loader for manual Sentry client. Import this instead of manual-sentry
 * so the @sentry/browser bundle is not in the main chunk.
 */

export interface IManualSentryClient {
  captureMessage(
    message: string,
    level: "info" | "warning" | "error",
    extra?: Record<string, unknown>,
  ): string | undefined;
  captureException(exception: unknown): string | undefined;
  setTag(key: string, value: string): void;
}

let instance: IManualSentryClient | null = null;

export async function getSentryManual(): Promise<IManualSentryClient> {
  if (instance) {
    return Promise.resolve(instance);
  }
  const m = await import("./manual-sentry");
  instance = m.sentryManual;
  return instance;
}

/** Proxy that defers to the real manual-sentry module when loaded. Methods return undefined (fire-and-forget). */
export const sentryManual: IManualSentryClient = {
  captureMessage(message, level, extra) {
    getSentryManual().then((m) => m.captureMessage(message, level, extra));
    return undefined;
  },
  captureException(exception) {
    getSentryManual().then((m) => m.captureException(exception));
    return undefined;
  },
  setTag(key, value) {
    getSentryManual().then((m) => m.setTag(key, value));
  },
};
